export default {"src":"/_next/static/media/Claim.aff82cdd.svg","height":92,"width":91};